import {APP_CONFIG} from "../../config/GeneralConfig";
import {UserViewSettings, UserViewSettingsProp} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {OutgoingInvoice, OutgoingInvoiceId} from "../../models/accounting/OutgoingInvoice";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map, switchMap} from "rxjs/operators";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";
import {OutgoingInvoiceModule} from "../../models/accounting/AccountBook";
import {IProjectLogEntry} from "../../models/projects/ProjectLog";
import {Identifier} from "../../models/common/Identifier";

/** backend api path */
function apiPath( id: number ): string {
    const uri = 'invoices/outgoing/'
    if( id === null ) {
        return APP_CONFIG.baseWeb + uri;
    } else {
        return APP_CONFIG.baseWeb + uri  + id + "/log";
    }
}


/** union of all Bill related action types */
export type OutgoingInvoiceProjectLogViewActionTypes = FetchOutgoingInvoicesProjectLogActionTypes



/**
 * fetch list of bills action types
 */
export interface FetchOutgoingInvoicesProjectLogAction extends OutgoingInvoiceId, UserViewSettingsProp, ReduxAction< typeof FETCH_OUTGOING_INVOICES_PROJECT_LOG > {}
export interface FetchOutgoingInvoicesProjectLogSuccessAction extends OutgoingInvoiceId, ReduxAction<typeof FETCH_OUTGOING_INVOICES_PROJECT_LOG_SUCCESS > {
    payload: ApiReturnType< IProjectLogEntry[] >

}
export interface FetchOutgoingInvoicesProjectLogErrorAction extends OutgoingInvoiceId, ErrorAction< typeof FETCH_OUTGOING_INVOICES_PROJECT_LOG_ERROR >{}

export type FetchOutgoingInvoicesProjectLogActionTypes = FetchOutgoingInvoicesProjectLogAction | FetchOutgoingInvoicesProjectLogErrorAction | FetchOutgoingInvoicesProjectLogSuccessAction

/**
 * redux action constants
 */
export const FETCH_OUTGOING_INVOICES_PROJECT_LOG = "FETCH_OUTGOING_INVOICES_PROJECT_LOG";
export const FETCH_OUTGOING_INVOICES_PROJECT_LOG_SUCCESS = "FETCH_OUTGOING_INVOICES_PROJECT_LOG_SUCCESS";
export const FETCH_OUTGOING_INVOICES_PROJECT_LOG_ERROR = "FETCH_OUTGOING_INVOICES_PROJECT_LOG_ERROR";

/**
 * redux action functions
 */
export function fetchOutgoingInvoicesProjectLog(
    outgoingInvoiceId: Identifier< number >,
    userViewSettings: UserViewSettings
) : FetchOutgoingInvoicesProjectLogAction {
    return { type: FETCH_OUTGOING_INVOICES_PROJECT_LOG, userViewSettings, outgoingInvoiceId };
}
export function fetchOutgoingInvoicesProjectLogSuccess(
    outgoingInvoiceId: Identifier< number >,
    payload: ApiReturnType< IProjectLogEntry[] >
) : FetchOutgoingInvoicesProjectLogSuccessAction {
    return { type: FETCH_OUTGOING_INVOICES_PROJECT_LOG_SUCCESS, payload, outgoingInvoiceId };
}
export function fetchOutgoingInvoicesProjectLogError(
    outgoingInvoiceId: Identifier<number>,
    error: Error
): FetchOutgoingInvoicesProjectLogErrorAction {
    return { type: FETCH_OUTGOING_INVOICES_PROJECT_LOG_ERROR, error, outgoingInvoiceId };
}

/**
 * redux observable to fetch bills from api
 */
export function fetchOutgoingInvoicesProjectLogEpic(
    action$: Observable< FetchOutgoingInvoicesProjectLogAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType(FETCH_OUTGOING_INVOICES_PROJECT_LOG),
        switchMap(action => {
            const path = `${ apiPath( action.outgoingInvoiceId.rawValue ) }${  getUrlParamsFromViewSettings( action.userViewSettings ) }`;

            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map(response => fetchOutgoingInvoicesProjectLogSuccess(
                    action.outgoingInvoiceId,
                    response.response as ApiReturnType< IProjectLogEntry[] >
                )),
                catchError(error => of(
                    fetchOutgoingInvoicesProjectLogError( action.outgoingInvoiceId, error),
                    eventNotificationError(error, store$, OutgoingInvoiceModule.identifier, "fetchOutgoingInvoicesProjectLog")
                ))
            );

        })
    );
}